export default "__VITE_ASSET__BR2tyCl1__"